module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1fig1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("1.1.")]), _vm._v(" Size comparison of the Pleistocene felid sabertooth "), _c('em', [_vm._v("Smilodon populator")]), _vm._v(" (background) and the Eocene creodont sabertooth "), _c('em', [_vm._v("Machaeroides")]), _vm._v(" eothen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a09b99d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/halftitle02.vue
// module id = 87
// module chunks = 0